import {products} from '@/services/products';
import productData from '@/data/productData.json';
export default {
  state: {
    productInfo: {
      category: null,
      products: []
    }
  },
  mutations: {
    setProductState(state, obj) {
      Object.assign(state.productInfo, obj);
    }
  },
  actions: {
    async loadProducts({commit}, {category}) {
      // products is cached at service level, it should be cached here...
      // This API doesn't make a ton of sense. just load all products all the time??
      let p = await products(category);
      commit('setProductState', {products: p, category});
    },
    async loadDefaultProductInfo({dispatch, state}) {
      let {category, apiName} = productData.defaultChoice;
      await dispatch('loadProducts', {category});
      console.log(state.productInfo.products);
    }
  },
  getters: {
    defaultProductSelector: state => {
      let {quantity, apiName, corners} = productData.defaultChoice;
      let result = {quantity}
      for (let prec of state.productInfo.products) {
        if (prec.name !== apiName) continue;
        // product recommendations have urls
        let attrs = {};
        prec.product.attributes.forEach(({sku_tag}) => {
          let m = /(sides|corners):\s*(.+)/.exec(sku_tag);
          attrs[m[1]] = m[2];
        });
        if (attrs.corners !== corners) continue;
        for (let price of prec.product.prices) {
          if (price.quantity === quantity) {
            result[attrs.sides] = price.stockrecord.product;
          }
        }
      }
      return result;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/products.js